var React = require('react');

function IconSocialOk (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-odnoklassniki","data-name":"Icon awesome-odnoklassniki","d":"M11.821,14.352a9.469,9.469,0,0,1-3.867,1.156l.9.885,3.279,3.279c1.2,1.229-.752,3.15-1.964,1.964C9.346,20.8,8.143,19.6,6.888,18.343L3.609,21.63C2.4,22.812.447,20.874,1.659,19.667c.834-.834,2.024-2.037,3.279-3.279l.885-.885a9.425,9.425,0,0,1-3.893-1.156c-1.4-.9-2.015-1.431-1.474-2.535.318-.627,1.19-1.156,2.346-.245a6.97,6.97,0,0,0,4.078,1.242,6.97,6.97,0,0,0,4.078-1.242c1.156-.907,2.024-.382,2.346.245C13.836,12.916,13.221,13.445,11.821,14.352ZM1.3,5.573a5.573,5.573,0,1,1,5.573,5.56A5.578,5.578,0,0,1,1.3,5.573Zm2.836,0a2.737,2.737,0,1,0,2.737-2.75A2.742,2.742,0,0,0,4.138,5.573Z","transform":"translate(-0.26)","fill":"#fff"}));
}

IconSocialOk.defaultProps = {"width":"13.233","height":"22.007","viewBox":"0 0 13.233 22.007"};

module.exports = IconSocialOk;

IconSocialOk.default = IconSocialOk;
